/**
 * This method is used to fetch draft list
 * @returns
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { setCollection, setCollectionTabList, setDefaultSnapshotData, } from "../store/reducers/overviewSlice";
import { setCollectionHRNs, setDraftsList, setErroCode, setIndoorCatalogHrn, setIsAuthorizedForRealmSetup, setIsLoaded, setIsNoMap, setIsRealmSetup, setMapsOnOverview, } from "../store/reducers/appSlice";
import { getConfigurationDetails, getDrafts } from "./venues";
import axios from "axios";
import { setInitialVenuesList, setVenuesList, } from "../store/reducers/venuesSlice";
import IndoorHelper from "../store/helpers/indoorHelper";
import translations from "../translations/resources/en-GB.json";
import _ from "lodash";
import { INDOOR_MAP, MapKeys, MAP_STATUS } from "../store/common/constants";
import { getCollectionsUrl } from "./platform";
import { getSnapshots } from "./internalTools";
import { ConfigService } from "../services/configservice";
export var getDraftsList = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var response, draftList, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getDrafts(getState().user.token)];
            case 1:
                response = (_b.sent());
                draftList = response === null || response === void 0 ? void 0 : response.draftHrns;
                dispatch(setDraftsList(draftList));
                return [3 /*break*/, 3];
            case 2:
                _a = _b.sent();
                console.log("error");
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
/**
 * This method is used to fetch all collection
 * @returns
 */
export var collectionHRN = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var user_1, filteredCollection, res, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                user_1 = getState().user.info;
                filteredCollection = getState().app.collectionHrns.filter(function (collection) { return collection.includes(":".concat(user_1.realm, ":")); });
                return [4 /*yield*/, getSnapshots(getState().user.token, filteredCollection[0])];
            case 1:
                res = _b.sent();
                dispatch(setDefaultSnapshotData(res === null || res === void 0 ? void 0 : res.data));
                dispatch(refreshCollectionCatalogForSvgRule(getState().app.collectionHrns, filteredCollection));
                return [3 /*break*/, 3];
            case 2:
                _a = _b.sent();
                console.log("error");
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var getConfiguration = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var res, e_1, user, userIsAdmin;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getConfigurationDetails(getState().user.token)];
            case 1:
                res = _d.sent();
                if (res.status === 200) {
                    dispatch(setIsRealmSetup(true));
                    dispatch(setIndoorCatalogHrn(res.data.mapsCatalogHrn));
                    dispatch(setCollectionHRNs(res.data.collectionCatalogHrns));
                }
                return [3 /*break*/, 3];
            case 2:
                e_1 = _d.sent();
                user = getState().user.info.roles;
                userIsAdmin = user.some(function (r) {
                    return INDOOR_MAP.AUTHORIZED_ROLES.includes(r);
                });
                if (((_a = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _a === void 0 ? void 0 : _a.status) === 404 && userIsAdmin) {
                    //realm is not setup
                    dispatch(setIsRealmSetup(false));
                    dispatch(setIsLoaded(true));
                    dispatch(setIsAuthorizedForRealmSetup(true));
                }
                else {
                    //for other common api failures
                    if ((_b = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _b === void 0 ? void 0 : _b.status) {
                        dispatch(setErroCode((_c = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _c === void 0 ? void 0 : _c.status));
                    }
                    else {
                        dispatch(setErroCode(401));
                    }
                    dispatch(setIsLoaded(true));
                    dispatch(setIsRealmSetup(false));
                }
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var axiosGetAPI = function (url, token) {
    return axios.get(url, {
        headers: {
            Authorization: "Bearer ".concat(token),
        },
    });
};
/**
 * This method return object
 * @param venues
 * @param user
 * @param draftsList
 * @param customerMapStatusResp
 * @returns object
 */
export var formattedVenueArray = function (venues, user, draftsList, env) {
    var envName = (env === null || env === void 0 ? void 0 : env.environmentId) === "prod" ? "here" : "here-dev";
    var checkDraft = function (v) {
        return draftsList.includes("hrn:".concat(envName, ":data::").concat(user === null || user === void 0 ? void 0 : user.realm, ":").concat(v === null || v === void 0 ? void 0 : v.id, "-draft"));
    };
    // reason stating 'null' here is if draft is true in VenueList we are checking for checked in checkout status
    // and if it is false then it is obvious checkin.
    //TODO: remove feature flag after filter implementation
    var getDraftStatus = function (isDraft) {
        var draftStatus = ConfigService.features.showDraftStatusFilter && isDraft
            ? MAP_STATUS[MapKeys.CHECKED_OUT].LABEL
            : isDraft
                ? null
                : MAP_STATUS[MapKeys.CHECKED_IN].LABEL;
        return draftStatus;
    };
    return venues === null || venues === void 0 ? void 0 : venues.map(function (v) {
        var lastUpdated = (user === null || user === void 0 ? void 0 : user.locale) &&
            (v === null || v === void 0 ? void 0 : v.modified) &&
            IndoorHelper.formattedDate(user.locale, new Date(v.modified));
        var createdOn = (user === null || user === void 0 ? void 0 : user.locale) &&
            (v === null || v === void 0 ? void 0 : v.created) &&
            IndoorHelper.formattedDate(user.locale, new Date(v.created));
        var isDraft = checkDraft(v);
        return __assign(__assign({}, v), { modified: lastUpdated, created: createdOn, isDraft: isDraft, draftStatus: getDraftStatus(isDraft), buttonText: translations.data["venonboard.details.cta.imc"], state: isDraft ? null : MAP_STATUS[MapKeys.READY].LABEL });
    });
};
export var formatVenueList = function (venues) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var user, draftsList, env, formattedVenue, response, mapsOnOverview;
    return __generator(this, function (_a) {
        user = getState().user.info;
        draftsList = getState().app.draftsList;
        env = getState().app.environment;
        formattedVenue = venues
            ? formattedVenueArray(venues, user, draftsList, env)
            : [];
        response = formattedVenue.length
            ? _.orderBy(formattedVenue, function (dateObj) {
                return new Date(dateObj.modified);
            }, ["desc"])
            : [];
        mapsOnOverview = response ? response.slice(0, 3) : [];
        dispatch(setMapsOnOverview(mapsOnOverview));
        // we need this copy in time of search
        dispatch(setInitialVenuesList(response));
        dispatch(setVenuesList(response));
        dispatch(setIsLoaded(true));
        return [2 /*return*/];
    });
}); }; };
export var refreshCollectionCatalogForSvgRule = function (collectionTabList, filteredcollectionHrnList) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var token, getCollection, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    token = getState().user.token;
                    if (!filteredcollectionHrnList[0]) return [3 /*break*/, 2];
                    getCollection = getCollectionsUrl() +
                        "/" +
                        filteredcollectionHrnList[0] +
                        INDOOR_MAP.RELOAD_ICONS_RULES_URL;
                    return [4 /*yield*/, axios.put(getCollection, null, {
                            headers: {
                                Authorization: "Bearer ".concat(token),
                            },
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    dispatch(setCollection(filteredcollectionHrnList));
                    dispatch(setCollectionTabList(collectionTabList));
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    dispatch(setIsLoaded(true));
                    dispatch(setIsNoMap(true));
                    dispatch(setErroCode(403));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
